import { render, staticRenderFns } from "./WsDemoExamsCertificateView.vue?vue&type=template&id=4b437d6e"
import script from "./WsDemoExamsCertificateView.vue?vue&type=script&lang=js"
export * from "./WsDemoExamsCertificateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports